var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecoverRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 30,
    viewBox: "0 0 35 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3096 2.59504C28.8496 -0.864947 23.2199 -0.864879 19.7599 2.59498L17.4544 4.90052L15.1489 2.59498C13.4191 0.865219 11.1462 0 8.87405 0C6.60137 0 4.32937 0.86481 2.59913 2.59498C0.923105 4.27107 0 6.49951 0 8.8699C0 11.2403 0.923105 13.4686 2.59913 15.1447L17.4544 30L32.3096 15.1447C33.9857 13.4686 34.9088 11.2402 34.9088 8.8699C34.9088 6.49958 33.9857 4.27114 32.3096 2.59504V2.59504ZM29.4522 11.848L20.4324 20.8678C19.56 21.7403 18.414 22.1764 17.268 22.1764C16.122 22.1764 14.976 21.7403 14.1035 20.8678C12.3587 19.1229 12.3587 16.2838 14.1035 14.5389L23.1234 5.51906C24.8685 3.77424 27.7075 3.77431 29.4522 5.51906C31.1971 7.26389 31.1971 10.1031 29.4522 11.848V11.848Z",
    fill: "#FF5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5476 15.9852C15.0887 16.4441 14.8359 17.0543 14.8359 17.7033C14.8359 18.3523 15.0887 18.9625 15.5476 19.4214C16.4951 20.3688 18.0365 20.3687 18.9838 19.4214L20.3293 18.0759L16.8931 14.6397L15.5476 15.9852Z",
    fill: "#FF5C5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3351 13.1942L21.7708 9.75851L25.2065 13.1943L21.7708 16.63L18.3351 13.1942Z",
    fill: "#FF5C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2843 6.25479C25.662 6.25479 25.0399 6.49165 24.5662 6.96531L23.2207 8.3108L26.657 11.7471L28.0024 10.4016C28.4613 9.94271 28.7141 9.33249 28.7141 8.68347C28.7141 8.03446 28.4613 7.4243 28.0024 6.96538C27.5288 6.49172 26.9064 6.25479 26.2843 6.25479Z",
    fill: "#FF5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecoverRed);
export default __webpack_public_path__ + "static/media/Recover-Red.81ffc19ac04a045a9b204645213e7dfe.svg";
export { ForwardRef as ReactComponent };